import { DefaultLayout } from "components";
import {
	HomePage,
	LoginPage,
	AvailableCoursesPage,
	NewsPage,
	SignupPage,
	HelpPage,
	MyCoursesPage,
	CoursePage,
	ModulePage,
	ManageUsers,
	ManageCourses,
	ManageNews,
	ManageClasses,
	ManageModules,
	RecoverPasswordPage,
	ManageProducts,
	ManageBanners,
	ManageNewsletter,
	NotFoundPage,
} from "pages";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { setIsAuthenticated, setUser } from "state";
import { IGeneralState } from "types";

const Router = () => {
	const { isAuthenticated } = useSelector(
		(state: IGeneralState) => state.login
	);
	const key = JSON.parse(`${localStorage.getItem("token")}`);
	const dispatch = useDispatch();

	useEffect(() => {
		if (key?.token) {
			dispatch(setIsAuthenticated(true));
			dispatch(
				setUser({
					email: key?.email,
					name: key?.person?.name,
					label: key?.label,
					id: key?.id,
					username: key?.username,
				})
			);
			console.log(window.location.pathname);
		}
		if (window.location.pathname === "/" && key?.token)
			window.location.replace("/dash");
		if (window.location.pathname === "/" && !key?.token)
			window.location.replace("/login");

		// eslint-disable-next-line
	}, []);

	return (
		<BrowserRouter>
			<Routes>
				{/* PUBLIC ROUTES */}
				<Route path="/login" element={<LoginPage />} />
				<Route path="/signup" element={<SignupPage />} />
				<Route path="/recover-password" element={<RecoverPasswordPage />} />

				<Route
					element={<DefaultLayout isAuthenticated={isAuthenticated || key} />}
				>
					{/* PLATAFORM ROUTES - LABEL: STUDENT */}
					<Route path="/dash" element={<HomePage />} />
					<Route path="/courses" element={<AvailableCoursesPage />} />
					<Route path="/news" element={<NewsPage />} />
					<Route path="/faq" element={<HelpPage />} />
					<Route path="/my-courses" element={<MyCoursesPage />} />
					<Route path="/my-courses/:id" element={<CoursePage />} />
					<Route path="/my-courses/:id/module/:id" element={<ModulePage />} />

					{/* PLATAFORM ROUTES - LABEL: MANAGER */}
					<Route path="/manage-users" element={<ManageUsers />} />

					<Route path="/manage-courses" element={<ManageCourses />} />
					<Route
						path="/manage-courses/course/:id"
						element={<ManageModules />}
					/>
					<Route
						path="/manage-courses/course/:id/module/:id"
						element={<ManageClasses />}
					/>
					<Route path="/manage-news" element={<ManageNews />} />
					<Route path="/manage-newsletter" element={<ManageNewsletter />} />
					<Route path="/manage-products" element={<ManageProducts />} />
					<Route path="/manage-banners" element={<ManageBanners />} />
				</Route>
				<Route path="*" element={<NotFoundPage />} />
			</Routes>
		</BrowserRouter>
	);
};

export default Router;
